import React, {useState} from 'react';
import {useDispatch} from 'react-redux';

import {labels} from '../../../../util/utils';
import {projectStatusEnum} from '../../../../util/uiconstants';

import {deleteProject} from '../../../../actions/Project/projectAction';

import ProjectConfirmationModal from '../ProjectConfirmationModal';

const DeleteModal = ({show, setShow, projectId, name, status}) => {
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();

	const onHide = () => setShow(false);

	const onConfirm = () => {
		if (status === projectStatusEnum.DRAFT || status === projectStatusEnum.ACTIVE) {
			setIsLoading(true);
			dispatch(deleteProject(projectId))
				.then(() => {
					setIsLoading(false);
					onHide();
				})
				.catch(() => setIsLoading(false));
		}
	};

	const props = {
		show,
		onHide,
		onConfirm,
		isLoading,
		title: labels.deleteProject,
		confirmLabel: labels.delete,
		instructional: labels.deleteProjectModalText,
		projectName: name || ''
	};

	return <ProjectConfirmationModal {...props} />;
};

DeleteModal.propTypes = {};

DeleteModal.defaultProps = {};

export default DeleteModal;
